import { Link } from "react-router-dom";
import type { Channel } from "@/mocks/channels";
import SectionHeading from "@/components/feature/SectionHeading";

export default function ChannelScroll({ items }: { items: Channel[] }) {
  return (
    <section aria-labelledby="hot-channels">
      <SectionHeading
        icon="ri-live-line"
        title="热门影视频道推荐"
        subtitle="发现优质观看源与内容专题"
        moreTo="/channel"
        moreLabel="全部频道"
      />
      {items.length === 0 ? (
        <p className="rounded-lg border border-dashed border-background-300 bg-background-100 px-4 py-8 text-center text-sm text-foreground-500">
          频道推荐更新中
        </p>
      ) : (
        <div className="no-scrollbar flex gap-3.5 overflow-x-auto pb-2">
          {items.map((channel) => (
            <Link
              key={channel.id}
              to={`/channel/${channel.id}`}
              className="group flex w-[230px] shrink-0 flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-accent-400"
            >
              <div className="h-[120px] w-full overflow-hidden bg-background-200">
                <img
                  src={channel.cover}
                  alt={`${channel.name} 频道封面`}
                  title={`${channel.name} - 黑桃视频影视频道推荐`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-3.5">
                <h5 className="text-sm font-500 text-foreground-950 transition-colors group-hover:text-accent-500">
                  {channel.name}
                </h5>
                <p className="mt-1 line-clamp-2 text-[11px] leading-relaxed text-foreground-600">
                  {channel.short}
                </p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}